if ($('.type-post').length) {

  var $pageTop = $('<div class="page-top"><div class="container"></div></div>');
  $pageTop.insertAfter('header#header');
  var $container = $pageTop.find('.container');

  var $breadcrumbsWrapper = $('<div class="breadcrumbs-wrapper"></div>');
  $('.breadcrumbs').appendTo($breadcrumbsWrapper);
  $breadcrumbsWrapper.appendTo($container);

  $('h1').first().appendTo($container);

  var $text = $('.news-item-detail > .text');
  var $hr = $text.find('hr').first();
  var hasHr = $hr.length > 0;

  if (hasHr) {

    var introHtml = '';
    $hr.prevAll().each(function () {
      introHtml = $(this).prop('outerHTML') + introHtml;
    });

    var bodyHtml = '';
    $hr.nextAll().each(function () {
      bodyHtml += $(this).prop('outerHTML');
    });

    if (introHtml.trim().length) {
      $('<div class="top-paragraph"></div>')
        .html(introHtml)
        .appendTo($container);
    }

    $text.html(bodyHtml);

  } else {
    $('<div class="top-paragraph"></div>').appendTo($container);
  }

  var ogImage = $('meta[property="og:image"]').attr('content');
  if (ogImage) {
    var $imgWrap = $('.top-image');
    if (!$imgWrap.length) {
      $imgWrap = $('<div class="top-image"><img alt=""></div>');
      $imgWrap.appendTo($container);
    }
    $imgWrap.find('img').attr('src', ogImage);
  }

  $('<div class="readTime"><span class="dobaCteni">–</span></div>')
    .appendTo('.top-paragraph');

  readingTimePost();
}

function readingTimePost() {
  const apiUrl = "https://php.shopcode.cz/api/celtic-supply/api-blog_reading_time.php";

  function getPostLanguage() {
    if (typeof getBlogLanguage === "function") {
      return getBlogLanguage();
    }

    var htmlLang = (document.documentElement.getAttribute("lang") || "").trim().toLowerCase().replace(/_/g, "-");
    var languageMap = {
      cs: "cs",
      "cs-cz": "cs",
      sk: "sk",
      "sk-sk": "sk",
      de: "de",
      "de-de": "de",
      "de-at": "de-at",
      pl: "pl",
      "pl-pl": "pl",
      nl: "nl",
      "nl-nl": "nl",
      fr: "fr",
      "fr-fr": "fr"
    };

    if (languageMap[htmlLang]) {
      return languageMap[htmlLang];
    }

    var primaryLanguage = htmlLang.split("-")[0];
    return languageMap[primaryLanguage] || "";
  }

  function normalizePath(url) {
    if (!url) return "";

    try {
      var parsedUrl = new URL(url, window.location.origin);
      var path = parsedUrl.pathname;
      if (path !== "/" && !path.endsWith("/")) {
        path += "/";
      }
      return path;
    } catch (error) {
      return "";
    }
  }

  var currentLanguage = getPostLanguage();
  if (!currentLanguage) {
    console.warn('⚠️ Nepodařilo se zjistit podporovaný jazyk z atributu <html lang="">.');
    return;
  }

  $.ajax({
    url: apiUrl,
    method: "GET",
    dataType: "json",
    cache: false,
    data: {
      lang: currentLanguage,
      limit: 500
    }
  })
    .done(function (resp) {
      if (!resp.data || !resp.data.length) return;

      const currentPath = normalizePath(window.location.pathname);

      const article = resp.data.find(item => {
        let itemUrl = normalizePath(item.url);
        return itemUrl === currentPath;
      });

      if (article) {
        const minutes = parseInt(article.reading_minutes, 10) || 1;
        $('.readTime .dobaCteni').text(sklonujMinutyPost(minutes));
      }
    })
    .fail(function (xhr, status, error) {
      console.error("❌ Chyba při načítání API:", {
        status: status,
        error: error,
        response: xhr.responseText,
        language: currentLanguage
      });
    });
}

function sklonujMinutyPost(n) {
  n = parseInt(n, 10);
  if (n === 1) return translation('minutaCteni');
  if (n >= 2 && n <= 4) return n + translation('minutyCteni');
  return n + translation('mintCteni');
}



if ($('.news-item-detail').length) {



  if ($('.news-item-detail .text ul[style="list-style-type: square;"]').length > 0) {
    var apiUrl = "https://php.shopcode.cz/api/celtic-supply/api-products.php";
    $('.news-item-detail .text ul[style="list-style-type: square;"]').each(function (index) {
      var $ul = $(this);
      $ul.hide();
      var codes = [];
      $ul.find('li').each(function () {
        var code = $(this).text().trim();
        if (code) codes.push(code);
      });
      if (codes.length === 0) return;

      $.ajax({
        url: apiUrl,
        type: "GET",
        data: {
          codes: codes.join(',')
        },
        dataType: "json",
        success: function (response) {

          if (!response || !Array.isArray(response.data) || response.data.length === 0) return;
          const $productPostsWrap = $(`
          <div class="postsProducts" id="postsProducts-${index}">
            <div id="products" class="products products-page products-block"></div>
          </div>
        `);
          $ul.after($productPostsWrap);
          const ordered = codes
            .map(code => response.data.find(item => item.code === code))
            .filter(Boolean); // odstraní undefined, pokud některý kód neexistuje
          ordered.forEach(item => {
            const nameEscaped = escapeHtmlAttr(item.name);
            const customClass = (document.location.href === item.orig_url) ? 'active' : '';
            const imageUrl = item.image && item.image.trim() !== ''
              ? item.image.replace('/orig/', '/detail/')
              : 'https://cdn.myshoptet.com/prj/dist/master/cms/img/common/missing_images/detail.png';


            let pricesHtml = '';
            if (item.action_price && Number(item.action_price) > 0) {
              pricesHtml = `
              <div class="prices superPrice">
                
                <div class="price price-final" data-testid="productCardPrice">
                  <strong>${Number(item.action_price).ShoptetFormatAsCurrency()}</strong>
                </div>
                <div class="price-standard">
                  <span>${Number(item.price_vat).ShoptetFormatAsCurrency()}</span>
                </div>
              </div>
            `;
            } else {
              pricesHtml = `
              <div class="prices">
                <div class="price price-final" data-testid="productCardPrice">
                  <strong>${Number(item.price_vat).ShoptetFormatAsCurrency()}</strong>
                </div>
              </div>
            `;
            }
            let discountFlagHtml = '';
            if (item.action_price && Number(item.action_price) > 0) {
              const percent = Math.round(
                (1 - Number(item.action_price) / Number(item.price_vat)) * 100
              );

              if (percent > 0) {
                discountFlagHtml = `
                <div class="flags flags-extra">
                  <span class="flag flag-discount">
                    <span class="price-save">–${percent} %</span>
                  </span>
                </div>
              `;
              }
            }
            const detailHtml = `
            <div class="product ${customClass}">
              <div class="p">
                <a href="${item.orig_url}" title="${nameEscaped}" class="image">
                   ${discountFlagHtml}
                  <img src="${imageUrl}" alt="${nameEscaped}">
                </a>
                <div class="p-in">
                   <div class="p-in-in">
                      <a class="name" href="${item.orig_url}">${item.name}</a>
                   </div>
                   <div class="p-bottom">
                    <div>
                      ${pricesHtml}
                      <div class="p-tools">
                        <a class="btn btn-primary" href="${item.orig_url}">Detail</a>
                      </div>
                    </div>
                   </div>
                </div>
                
              </div>
            </div>`;
            $productPostsWrap.find('#products').append(detailHtml);
          });

          // Slick slider
          $productPostsWrap.find('#products').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: false,
            autoplay: false,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false,
            infinite: false,
            adaptiveHeight: false,
            //appendArrows: $arrows, // 💡 šipky půjdou právě do této .brandArrows
            responsive: [
              { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
              { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
              { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1, arrows: false } },
              { breakpoint: 330, settings: { slidesToShow: 1, slidesToScroll: 1, arrows: false } }
            ]
          });

        },
        error: function (xhr, status, error) {
          console.error("Chyba při volání API:", error);
        }
      });
    });

    function escapeHtmlAttr(text) {
      return text
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
    }

  }

}